const inspectionTypes = {
  request: 'request',
  schedule: 'schedule',
};

export { inspectionTypes };
